export const MAX_ATTRIBUTE_DICE = 18
export const PIPS_IN_DIE = 3
export const ATTRIBUTE_DIE_COSTS = 4
export const MAX_SKILL_DICE = 9
export const MAX_TOTAL_SKILL_DICE = 7
export const SKILL_DIE_COSTS = 1

export const ATTRIBUTE_DIE = 0
export const SKILL_DIE = 1;

export const ADD_CHARACTER = 'ADD_CHARACTER'
export const ADD_SKILL = 'ADD_SKILL'
export const BUY_DIE = 'BUY_DIE'
export const CHANGE_AGE = 'CHANGE_AGE'
export const CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION'
export const CHANGE_GAME_TYPE = 'CHANGE_GAME_TYPE'
export const CHANGE_NAME = 'CHANGE_NAME'
export const CHANGE_OCCUPATION = 'CHANGE_OCCUPATION'
export const CHANGE_ATTRIBUTE = 'CHANGE_ATTRIBUTE'
export const CHANGE_SKILL = 'CHANGE_SKILL'
export const CHANGE_PROPERTY = 'CHANGE_PROPERTY'
export const DECREMENT_ATTRIBUTE = 'DECREMENT_ATTRIBUTE'
export const DECREMENT_SKILL = 'DECREMENT_SKILL'
export const EXPORT_TO_JSON = 'EXPORT_TO_JSON'
export const INCREMENT_ATTRIBUTE = 'INCREMENT_ATTRIBUTE'
export const INCREMENT_SKILL = 'INCREMENT_SKILL'
export const NEW_CHARACTER = 'NEW_CHARACTER'
export const REMOVE_CHARACTER = 'REMOVE_CHARACTER'
export const SET_ACTIVE_CHARACTER = 'SET_ACTIVE_CHARACTER'
export const STATE_FROM_CACHE = 'STATE_FROM_CACHE'
export const GEN_NAME = 'GEN_NAME'
export const GEN_OCCUPATION = 'GEN_OCCUPATION'